
import { HeaderMobile, FooterMobile } from "@components";
import { CommentComponentContextProps, KnowledgeHubBookContextProps, KnowledgeHubBookProps, TagTypes } from "@models/ui";
import React, { useContext, useState } from "react";
import { motion } from "framer-motion";
import CommentsLoginPopUpLoginMobile from "./comments-login-pop-up";
import SummaryLoginPopUpLoginMobile from "./summary-login-pop-up";
import InputCommentComponent from "./input-comment.component";
import CommentComponent from "./comment-mobile.component";
import { CommentComponentContext, KhBookContext } from "../../kh-book-context";
import { useNavigate } from "@remix-run/react";
import { classNames, mixpanelService } from "@utilities";

const tags: TagTypes[] = [
    { tag: "Leadership", color: "blue" },
    { tag: "Strategy", color: "green" },
    { tag: "People", color: "indigo" },
    { tag: "Sales & Marketing", color: "purple" },
    { tag: "Process", color: "pink" },
    { tag: "Finance", color: "orange" },
];

const MobileComponent: React.FC<KnowledgeHubBookProps> = (khBookProps) => {

    const KhBookData = useContext<KnowledgeHubBookContextProps>(KhBookContext);
    const navigate = useNavigate();
    const [isViewAllComments, setIsViewAllComments] = useState<boolean>(KhBookData?.comments?.length > 2 ? true : false);
    const [isResourceCommentSectionOpen, setIsResourceCommentSectionOpen] = useState<boolean>(false);

    const handleCommentClick = () => {
        if (!KhBookData.isLoggedIn) {
            khBookProps.setIsCommentsPopupOpen(true);
            setIsResourceCommentSectionOpen(false);
        }
        else {
            setIsResourceCommentSectionOpen(prevIsResourceCommentSectionOpen => !prevIsResourceCommentSectionOpen);
            setTimeout(() => {
                if (KhBookData.inputRef.current) {
                    KhBookData.inputRef.current.focus(); // Focus on the input immediately
                }
            }, 0);
        }
    };

    return (
        <>
            <HeaderMobile headerProps={KhBookData.headerProps} />
            <div className="articles-book-div relative">
                <button onClick={() => navigate(-1)} className="nav-bar">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
                        <path d="M1.39244 6.30009H15.3044C15.4889 6.30009 15.6658 6.37383 15.7963 6.50509C15.9267 6.63635 16 6.81437 16 7C16 7.18563 15.9267 7.36365 15.7963 7.49491C15.6658 7.62617 15.4889 7.69991 15.3044 7.69991H1.39244C1.20796 7.69991 1.03103 7.62617 0.900578 7.49491C0.770128 7.36365 0.696842 7.18563 0.696842 7C0.696842 6.81437 0.770128 6.63635 0.900578 6.50509C1.03103 6.37383 1.20796 6.30009 1.39244 6.30009Z" fill="#625B70" />
                        <path d="M1.68042 7L7.44971 12.8037C7.58032 12.9351 7.6537 13.1133 7.6537 13.2992C7.6537 13.4851 7.58032 13.6633 7.44971 13.7947C7.31909 13.9262 7.14194 14 6.95722 14C6.77251 14 6.59536 13.9262 6.46474 13.7947L0.204358 7.49554C0.139579 7.43052 0.0881848 7.35329 0.0531177 7.26825C0.0180506 7.18322 0 7.09206 0 7C0 6.90794 0.0180506 6.81678 0.0531177 6.73175C0.0881848 6.64672 0.139579 6.56948 0.204358 6.50446L6.46474 0.205258C6.59536 0.0738335 6.77251 0 6.95722 0C7.14194 0 7.31909 0.0738335 7.44971 0.205258C7.58032 0.336683 7.6537 0.514933 7.6537 0.700796C7.6537 0.886658 7.58032 1.06491 7.44971 1.19633L1.68042 7Z" fill="#625B70" />
                    </svg>
                    <p className="text">Back</p>
                </button>

                {KhBookData.isPopupLinkVisible ? (
                    <div className="link-copy-div">
                        <div className="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <g clipPath="url(#clip0_3692_27231)">
                                    <circle cx="12" cy="12" r="10" fill="#165DA1" />
                                    <path d="M10.3625 15.6075L9.3815 16.5599C9.12426 16.8168 8.77535 16.9612 8.41155 16.9612C8.04774 16.9612 7.69884 16.8168 7.44159 16.5599C7.18434 16.3029 7.03982 15.9543 7.03982 15.5909C7.03982 15.2274 7.18434 14.8789 7.44159 14.6219L9.95793 12.1025C10.2049 11.855 10.5377 11.7118 10.8874 11.7025C11.2372 11.6932 11.5771 11.8186 11.8369 12.0527L11.9034 12.1081C12.0085 12.2109 12.1502 12.2677 12.2972 12.2662C12.4443 12.2646 12.5848 12.2047 12.6877 12.0997C12.7906 11.9947 12.8475 11.8532 12.8459 11.7063C12.8444 11.5593 12.7845 11.4191 12.6794 11.3163C12.6479 11.276 12.6146 11.2372 12.5796 11.2C12.1064 10.7887 11.4945 10.5725 10.8678 10.5952C10.2411 10.6178 9.64635 10.8775 9.20414 11.3218L6.65454 13.8412C6.22131 14.3122 5.987 14.9323 6.00056 15.5719C6.01411 16.2115 6.27448 16.8211 6.72728 17.2734C7.18008 17.7258 7.79031 17.9859 8.43053 17.9994C9.07075 18.013 9.69145 17.7789 10.163 17.3461L11.1219 16.4103C11.2166 16.3072 11.2686 16.172 11.2675 16.032C11.2665 15.8921 11.2124 15.7577 11.1162 15.6559C11.02 15.5542 10.8887 15.4926 10.7489 15.4836C10.6091 15.4746 10.471 15.5189 10.3625 15.6075ZM16.2876 7.7227C15.8213 7.25981 15.1907 7 14.5334 7C13.876 7 13.2454 7.25981 12.7791 7.7227L11.8203 8.65847C11.7256 8.76165 11.6735 8.89683 11.6746 9.0368C11.6756 9.17676 11.7297 9.31114 11.826 9.41288C11.9222 9.51463 12.0534 9.57619 12.1932 9.58518C12.3331 9.59417 12.4711 9.54992 12.5796 9.46134L13.5385 8.50897C13.7957 8.25198 14.1446 8.1076 14.5084 8.1076C14.8722 8.1076 15.2211 8.25198 15.4784 8.50897C15.7356 8.76596 15.8801 9.11451 15.8801 9.47795C15.8801 9.84139 15.7356 10.1899 15.4784 10.4469L12.962 12.9663C12.715 13.2138 12.3823 13.3571 12.0325 13.3663C11.6828 13.3756 11.3429 13.2502 11.0831 13.0161L11.0166 12.9608C10.9115 12.858 10.7698 12.8011 10.6227 12.8026C10.4756 12.8042 10.3352 12.8641 10.2323 12.9691C10.1294 13.0741 10.0725 13.2156 10.074 13.3625C10.0756 13.5095 10.1355 13.6498 10.2406 13.7526C10.2811 13.7935 10.3236 13.8323 10.3681 13.8688C10.8418 14.2788 11.4535 14.4942 12.0798 14.4716C12.7062 14.449 13.3007 14.1901 13.7435 13.747L16.2654 11.2277C16.7317 10.7648 16.9958 10.1364 17 9.47975C17.0041 8.82307 16.748 8.19141 16.2876 7.7227Z" fill="#AFBFCF" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_3692_27231">
                                        <rect width="24" height="24" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                        <div className="text-section">
                            <p className="text">Link copied to clipboard!</p>
                        </div>
                        {/* <button className="flex items-start absolute gap-[10px] p-[6px] right-[8px] top-[8px]" onClick={handleCrossClick}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                <path d="M1 9L5 5L9 9M9 1L4.99924 5L1 1" stroke="#667085" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button> */}
                    </div>
                ) : null}

                {KhBookData.isCommentsPopupOpen && <CommentsLoginPopUpLoginMobile isCommentsPopupOpen={KhBookData.isCommentsPopupOpen} onPopupClose={() => khBookProps.setIsCommentsPopupOpen(false)} />}
                {KhBookData.isSummaryPopupOpen && <SummaryLoginPopUpLoginMobile isSummaryPopupOpen={KhBookData.isSummaryPopupOpen} onPopupClose={() => khBookProps.handleSummaryPopupClose()} />}

                <div className="image-div" style={{
                    backgroundImage: `url(${KhBookData.data?.imageMedium})`,
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100%",
                }}
                >
                    <div className="author-div">
                        <p className="author-name">{KhBookData.data?.author}</p>
                    </div>
                </div>

                <div className="info-div">
                    <div className="top-section">
                        <p className="header"> {KhBookData.data?.header} </p>
                        <p className="author"> by {KhBookData.data?.author} </p>
                        <div className="section">
                            <div className="tags">
                                {KhBookData.data?.tags?.map((tag, index) => {
                                    const t = tags.find(
                                        (x) => x.tag.toLowerCase() === tag.toLowerCase()
                                    );
                                    return (
                                        <div
                                            key={index}
                                            className={classNames("tag", t?.color ?? "")}
                                        >
                                            {tag}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    <div className="mid-section">
                        <p className="short-desc"> {KhBookData.data?.shortDesc} </p>
                        <div className="description-div">
                            <p className="long-desc-title">More about the book:</p>
                        </div>
                        {KhBookData.isOpen ? (
                            <div>
                                <motion.p
                                    initial="collapsed"
                                    animate={KhBookData.isOpen ? "open" : "collapsed"}
                                    exit="collapsed"
                                    variants={{
                                        open: {
                                            opacity: 1,
                                            height: "auto",
                                            visibility: "visible",
                                        },
                                        collapsed: {
                                            opacity: 0,
                                            height: 0,
                                            transitionEnd: { visibility: "hidden" },
                                        },
                                    }}
                                    transition={{ duration: 0.5, ease: "linear" }}
                                    className="description"
                                >
                                    {KhBookData.data?.longDesc}
                                </motion.p>
                                <button
                                    className="read-more pt-4"
                                    onClick={() => khBookProps.setIsOpen((prevIsOpen) => !prevIsOpen)}> Read less </button>
                            </div>
                        ) : (
                            <>
                                <div className="flex gap-0 items-end">
                                    <p className="long-desc">{KhBookData.data?.longDesc}</p>
                                </div>

                                <button className="read-more" onClick={() => khBookProps.setIsOpen((prevIsOpen) => !prevIsOpen)}>
                                    Read More
                                </button>
                            </>
                        )}
                    </div>
                </div>

                <div className="btn-div">
                    <a href={KhBookData.data?.resourceLink ?? ""} className="buy-button" onClick={() => {                        
                        mixpanelService.track("buy_book_click", {
                            resource_name: KhBookData.data?.header,
                            location: "individual_resources_page"
                        })
                        
                    }} rel="noopener noreferrer"
                        target="_blank">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M18.2182 14.2921L17.503 13.1869C17.2826 12.8462 17.1654 12.4492 17.1654 12.0434V7.4009C17.1654 5.54774 17.2996 1.59961 12.0087 1.59961C7.70453 1.59961 6.37355 3.89344 5.96201 5.31219C5.7986 5.87544 6.18257 6.44897 6.76597 6.50916L8.43422 6.68128C8.8269 6.72178 9.20344 6.51336 9.37375 6.15723C9.69713 5.48083 10.2608 4.47348 12.0003 4.47348C12.6742 4.47348 13.6218 4.7585 13.6218 5.59185C13.6218 6.80102 13.6202 7.37409 13.6202 7.37409C13.6247 7.62643 13.4214 7.83349 13.169 7.83349H11.5384C10.308 7.83349 5.63281 8.46443 5.63281 13.1397C5.63281 17.8149 10.5938 17.277 10.9232 17.1998C11.5378 17.0558 12.6891 16.6352 13.7712 15.6034C13.953 15.4301 14.2431 15.4452 14.401 15.6406L15.2748 16.7218C15.6144 17.1422 16.2392 17.1863 16.6347 16.8181L18.071 15.4803C18.4016 15.1723 18.4637 14.6715 18.2182 14.2921ZM11.0462 14.0316C9.38524 14.0316 9.43259 12.5299 9.81584 11.817C10.1744 11.15 11.1218 9.96753 13.6653 9.88699L13.6876 11.1278C13.7042 12.0502 13.2798 12.9362 12.5253 13.467C12.0579 13.796 11.5478 14.0316 11.0462 14.0316Z" fill="white" />
                            <path d="M0.0990564 18.3005C-0.153538 18.0723 0.121338 17.6681 0.4267 17.8185C2.57282 18.8757 6.61311 20.5102 11.0792 20.5102C15.6431 20.5102 19.4612 19.42 21.3829 18.7472C21.6954 18.6378 21.9205 19.0468 21.6633 19.2553C20.1387 20.4901 16.8645 22.4004 11.1992 22.4004C5.555 22.4004 1.88873 19.9178 0.0990564 18.3005Z" fill="#FFAC35" />
                            <path d="M19.3715 17.6352C19.9669 17.1944 21.446 16.4345 23.6566 17.0989C23.8598 17.16 23.9982 17.3479 23.9998 17.56C24.0052 18.2853 23.8489 19.988 22.4292 21.403C22.3306 21.5012 22.1647 21.4048 22.2011 21.2705C22.4436 20.3776 22.9365 18.4625 22.7801 18.1953C22.6008 17.889 20.3604 17.8744 19.4526 17.8812C19.3202 17.8822 19.2651 17.714 19.3715 17.6352Z" fill="#FFAC35" />
                        </svg>
                        <p className="text-nowrap"> Buy Book </p>
                    </a>
                    <button className="summary-btn-mobile text-nowrap" onClick={() => khBookProps.handleReadSummary(KhBookData.data?.header ?? "", KhBookData?.data?.resourceLocation ?? "")}> Read Book Summary </button>
                </div>

                <div className="like-share-section">
                    <div className="line"></div>
                    <div className="like-share-buttons">
                        <button className="buttons space-x-6" onClick={() => khBookProps.handleResourceLikeClick()}>
                            <div className="relative inline-block cursor-pointer mb-6">
                                {/* First SVG (Heart) */}
                                <motion.svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    initial={{ scale: 1, opacity: 1 }}
                                    animate={{
                                        scale: KhBookData.isLikeButton ? 0.5 : 1, // Shrink on click
                                        opacity: KhBookData.isLikeButton ? 0 : 1, // Fade out
                                        rotate: KhBookData.isLikeButton ? 360 : 0 // Rotate
                                    }}
                                    transition={{ duration: 0.5 }}
                                    className="absolute"
                                >
                                    <path d="M12.62 20.81C12.28 20.93 11.72 20.93 11.38 20.81C8.48 19.82 2 15.69 2 8.68998C2 5.59998 4.49 3.09998 7.56 3.09998C9.38 3.09998 10.99 3.97998 12 5.33998C13.01 3.97998 14.63 3.09998 16.44 3.09998C19.51 3.09998 22 5.59998 22 8.68998C22 15.69 15.52 19.82 12.62 20.81Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </motion.svg>
                                {/* Second SVG (Filled Heart) */}
                                <motion.svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    initial={{ scale: 0, opacity: 0, rotate: 0 }} // Start hidden
                                    animate={{
                                        scale: KhBookData.isLikeButton ? 1 : 0, // Grow to actual size
                                        opacity: KhBookData.isLikeButton ? 1 : 0, // Fade in
                                        rotate: KhBookData.isLikeButton ? 360 : 0 // Rotate
                                    }}
                                    transition={{ duration: 0.5 }}
                                    className="absolute "
                                >
                                    <path d="M12.62 20.81C12.28 20.93 11.72 20.93 11.38 20.81C8.48 19.82 2 15.69 2 8.68998C2 5.59998 4.49 3.09998 7.56 3.09998C9.38 3.09998 10.99 3.97998 12 5.33998C13.01 3.97998 14.63 3.09998 16.44 3.09998C19.51 3.09998 22 5.59998 22 8.68998C22 15.69 15.52 19.82 12.62 20.81Z" fill="#EB5050" stroke="#EB5050" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
                                    />
                                </motion.svg>
                            </div>

                            <p className="text"> {KhBookData.likes.noOfLikes} </p>
                        </button>

                        <button className="buttons cursor-pointer" onClick={handleCommentClick}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path d="M1 17L2.15466 13.1052C0.0904842 9.67271 0.888087 5.24358 4.01988 2.74489C7.15167 0.247204 11.6495 0.451933 14.5406 3.22426C17.4317 5.99758 17.8225 10.4806 15.4546 13.7114C13.0866 16.9421 8.69092 17.9208 5.17454 16.0013L1 17Z" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <p className="text"> {KhBookData.comments?.length} </p>
                        </button>

                        <button className="buttons cursor-pointer" onClick={() => khBookProps.handleShareClick()}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M13.75 11.875L17.5 8.125L13.75 4.375" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M2.5 15.625C2.5 13.6359 3.29018 11.7282 4.6967 10.3217C6.10322 8.91518 8.01088 8.125 10 8.125H17.5" stroke="#292D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <p className="text">Share</p>
                        </button>
                    </div>
                </div>

                <div className="comment-text">
                    <p className="text">Comments</p>
                </div>

                {isResourceCommentSectionOpen ? (
                    <InputCommentComponent setComments={khBookProps.setComments} handleCommentClick={handleCommentClick} setIsCommentsPopupOpen={khBookProps.setIsCommentsPopupOpen} />
                ) : null}

                {KhBookData.comments.slice(0, 2).map((comment, index) => {
                    const commentData: CommentComponentContextProps = {
                        comment: comment,
                        level: 0,
                    }

                    return (
                        <CommentComponentContext.Provider key={index} value={commentData}>
                            <CommentComponent handleCommentClick={handleCommentClick} setComments={khBookProps.setComments} handlePopupToggle={khBookProps.handlePopupToggle} handleReactionPopupClose={khBookProps.handleReactionPopupClose} setIsCommentsPopupOpen={khBookProps.setIsCommentsPopupOpen} />
                        </CommentComponentContext.Provider>
                    )
                })}

                {
                    isViewAllComments ?
                        <button className="view-all" onClick={() => setIsViewAllComments(false)}>View all comments</button>
                        :
                        KhBookData.comments.slice(2).map((comment, index) => {
                            const commentData: CommentComponentContextProps = {
                                comment: comment,
                                level: 0,
                            }

                            return (
                                <CommentComponentContext.Provider key={index} value={commentData}>
                                    <CommentComponent handleCommentClick={handleCommentClick} setComments={khBookProps.setComments} handlePopupToggle={khBookProps.handlePopupToggle} handleReactionPopupClose={khBookProps.handleReactionPopupClose} setIsCommentsPopupOpen={khBookProps.setIsCommentsPopupOpen} />
                                </CommentComponentContext.Provider>
                            )
                        })
                }

            </div>

            <FooterMobile footerCopyright={false} />
        </>
    )
}

export default MobileComponent;
